import { ReactElement } from 'react';
import { useViewProvider } from '../../modules/contexts/view-provider-context/ViewProvider';

export function ErrorPage(): ReactElement {
  const viewProvider = useViewProvider();

  return viewProvider.renderErrorPage();
}
